/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IBodegaPropiedadesAccion from './entidades/bodegaPropiedadesAccion';
import IBodegaPropiedadesFiltro from './entidades/bodegaPropiedadesFiltro';

export default class ModeloBodegasPropiedades {
    public consultarBodegasTiposPropiedades(bodegaPropiedades: IBodegaPropiedadesFiltro) {
        return manejadorRest<IRespuesta<IBodegaPropiedadesAccion>>(
            () => negocioConfiguracion.post('BodegaPropiedad/ConsultarBodegaPropiedadesCompuestaFiltro', bodegaPropiedades),
            true
        );
    }
}
